/**
 * Calculate "Tiền VND" for a single row
 * Formula:
 * - Always prioritize manually entered tien_nt value if available
 * - For ma_ngv = 1 (Theo hóa đơn): Tiền VND = Còn lại (cl_nt) × Tỷ giá hóa đơn (ty_gia_hd)
 * - For ma_ngv = 2 (Theo khách hàng): Use manually entered tien_nt value
 *
 * @param row - Detail row data
 * @param ma_ngv - Type of receipt (1 = by invoice, 2 = by customer)
 * @returns Calculated or manually entered Tiền VND amount
 */
export const calculateTienVnd = (row: BanHangRecord, ma_ngv?: string): number => {
  // Always prioritize manually entered value if available
  if (row.tien_nt !== undefined && row.tien_nt !== null) {
    const result = Number(row.tien_nt);
    return result;
  }

  // For ma_ngv = 2 (Theo khách hàng), use manually entered value (fallback to 0)
  if (ma_ngv === '2') {
    const result = 0;
    return result;
  }

  // For ma_ngv = 1 (Theo hóa đơn), calculate from invoice data
  // Get "Còn lại" amount from invoice data or row data
  const conLai = Number(row.id_hd_data?.tien_con_phai_tt || row.cl_nt || 0);

  // Get exchange rate from row data (default to 1)
  const tyGiaHd = Number(row.ty_gia_hd || 1);

  // Calculate from conLai * tyGiaHd
  // Round to 2 decimal places to avoid floating point precision issues
  const result = Math.round(conLai * tyGiaHd * 100) / 100;
  return result;
};

/**
 * Calculate total amount from all detail rows
 *
 * @param detailRows - Array of detail row data
 * @param ma_ngv - Type of receipt (1 = by invoice, 2 = by customer)
 * @returns Total amount (sum of all Tiền VND)
 */
export const calculateTotalAmount = (detailRows: BanHangRecord[], ma_ngv?: string): number => {
  const total = detailRows.reduce((sum, row) => {
    const rowAmount = calculateTienVnd(row, ma_ngv);
    return sum + rowAmount;
  }, 0);

  return total;
};
